module.exports = __webpack_public_path__ + "img/apple-white.49410046.svg";